module.exports = __webpack_public_path__ + "media/images/pc/specials/common/present_wayo-7c588952d30cf2148f3416f68b1a4802.png";